var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"youtube-player a-box-xs-16x9"},[_c('div',{staticClass:"a-box-content"},[_c('video-player',{ref:"videoPlayer",attrs:{"options":_vm.playerOptions}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }